module.exports = __webpack_public_path__ + "img/done-check-green.c4abfdab.svg";